import { c as _c } from "react/compiler-runtime";
import { BadgeCot, BadgeMember, BadgeTot } from '@shared/ui-components/svgs';
import { MembershipLevel } from '../../../../utils/enums/membership';
import styles from './membership-level-label.module.scss';
const membershipLevelBadgeMap = {
  [MembershipLevel.COT]: BadgeCot,
  [MembershipLevel.MDRT]: BadgeMember,
  [MembershipLevel.TOT]: BadgeTot
};
export const MembershipLevelLabel = t0 => {
  const $ = _c(8);
  const {
    label,
    membershipLevel
  } = t0;
  const Badge = membershipLevelBadgeMap[membershipLevel];
  let t1;
  if ($[0] !== Badge || $[1] !== label) {
    t1 = <Badge aria-label={label} className={styles.label__badge} />;
    $[0] = Badge;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== label) {
    t2 = <span>{label}</span>;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <span className={styles.label}>{t1}{t2}</span>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};